<?xml version="1.0" encoding="UTF-8"?>
<svg width="14px" height="13px" viewBox="0 0 14 13" fill="#878787" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Group-9">
            <rect id="Rectangle" x="0" y="0" width="4" height="3" rx="1"></rect>
            <rect id="Rectangle" x="0" y="5" width="4" height="3" rx="1"></rect>
            <rect id="Rectangle" x="0" y="10" width="4" height="3" rx="1"></rect>
            <rect id="Rectangle" x="6" y="10" width="8" height="3" rx="1"></rect>
            <rect id="Rectangle" x="6" y="5" width="8" height="3" rx="1"></rect>
            <rect id="Rectangle" x="6" y="0" width="8" height="3" rx="1"></rect>
        </g>
</svg>